import React, { PropsWithChildren } from 'react';

import styles from './dictionary-components.module.scss';

export default function AkItalic({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkItalic}>{children}</span>;
}
